/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';

import { vappContainer } from '@/application';
import { AppNavigatorService } from '@/AppNavigator/services';
import { kycFormConfig } from '../../config/kyc-form.config';

import { Graphql } from '@common/graphql';
import { apiConfig } from '@/config/apiConfig';
import { GET_MY_PROFILE } from '@pages/BuyInsurancePage/apis/graphql';

import { StorageModule } from '@vlinder-web/storage-module-react';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface IKYCFormDataMethods extends IPluginMethodMap {
  getKYCFormDataContent(): any;
}

const lookup = require('country-code-lookup');

export class KYCFormDataPlugin implements IAgentPlugin {
  readonly methods: IKYCFormDataMethods;
  constructor() {
    this.methods = {
      getKYCFormDataContent: this.getProps.bind(this),
    };
  }
  async getProps() {
    return await this.getProfile();
  }

  private async getProfile() {
    const storageSrv = StorageModule.getInstance();
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      // const token = getToken();
      const token = loginSrv()?.getToken();
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      const res = await client.query(GET_MY_PROFILE, {}).toPromise();
      if (res?.data?.getMyProfile) {
        let _res = res?.data?.getMyProfile;
        storageSrv.set('myProfile', _res, 'session');
        return {
          FIELDS: this.getFields(_res),
          layout: kycFormConfig?.layout,
          validatorConfig: kycFormConfig?.validatorConfig,
          policyHolder: {
            firstName: _res?.firstName,
            lastName: _res?.lastName,
            email: _res?.email,
            telephone: _res?.primaryContactNo,
            streetAddress: _res?.address?.addressLine1,
            city: _res?.address?.city,
            country: _res?.address?.country
              ? lookup.byIso(_res?.address?.country)?.country
              : '-',
          },
          kycSubmitted: _res?.kycSubmitted,
        };
      }
    } catch (err: any) {
      // log.error('error in capsules=', err?.message);
      throw Error(err?.response?.data?.error?.display_message);
    }
  }

  private getFields(res: any) {
    let filterFields = kycFormConfig?.filterIds;
    if (res?.kycSubmitted) {
      let _temp1 = res.kyc?.find((i: any) => i?.type === 'ADDRESS_PROOF');
      let _temp2 = res.kyc?.find((i: any) => i?.type === 'ID_PROOF');
      console.log('id proof:', _temp1, _temp2);
      if (!_temp1) {
        filterFields.unshift('addressProofType');
        filterFields.unshift('addressProof');
      }
      if (!_temp2) {
        filterFields.unshift('idProofType');
        filterFields.unshift('idProof');
      }

      let filteredArray = kycFormConfig?.FIELDS?.filter((i) =>
        filterFields.includes(i.compProps?.id)
      );
      return filteredArray;
    } else {
      return kycFormConfig?.FIELDS;
    }
  }
}
